export const FileManagement = "FileManagement/";
export const FileManagementUpload = FileManagement + 'Upload/';
export const FileManagementImport = FileManagement + 'Import/';


export const FileManagementUploadSearch = FileManagementUpload + 'Search';
export const FileManagementImportSearch = FileManagementImport + 'Search';